import React from 'react';
import { Route } from 'react-router-dom';
import OrganizationListPage from '../resources/organizations/pages/OrganizationListPage';
import OrganizationCreatePage from '../resources/organizations/pages/OrganizationCreatePage';
import OrganizationDetailsPage from '../resources/organizations/pages/OrganizationDetailsPage';
import OrganizationEditPage from '../resources/organizations/pages/OrganizationEditPage';
import PartnerListPage from '../resources/partners/pages/PartnerListPage';
import PartnerCreatePage from '../resources/partners/pages/PartnerCreatePage';
import PartnerDetailsPage from '../resources/partners/pages/PartnerDetailsPage';
import PartnerEditPage from '../resources/partners/pages/PartnerEditPage';
import ProductListPage from '../resources/products/pages/ProductListPage';
import ProductCreatePage from '../resources/products/pages/ProductCreatePage';
import ProductDetailsPage from '../resources/products/pages/ProductDetailsPage';
import ProductEditPage from '../resources/products/pages/ProductEditPage';
import SubscriptionListPage from '../resources/subscriptions/pages/SubscriptionListPage';
import SubscriptionCreatePage from '../resources/subscriptions/pages/SubscriptionCreatePage';
import SubscriptionDetailsPage from '../resources/subscriptions/pages/SubscriptionDetailsPage';
import SubscriptionEditPage from '../resources/subscriptions/pages/SubscriptionEditPage';
import MeterListPage from '../resources/meters/pages/MeterListPage';
import MeterCreatePage from '../resources/meters/pages/MeterCreatePage';
import MeterDetailsPage from '../resources/meters/pages/MeterDetailsPage';
import MeterEditPage from '../resources/meters/pages/MeterEditPage';
import RequireReadPermission from '../components/RequireReadPermission';
import RequireWritePermission from '../components/RequireWritePermission';

const AuthenticatedRoutes = () => {
  let configuredFeatures = [];
  configuredFeatures.push(
    <React.Fragment key={'organizations'}>
      <Route
        path={`/organizations`}
        element={
          <RequireReadPermission resource="organizations">
            <OrganizationListPage />
          </RequireReadPermission>
        }
      />
      <Route
        path={`/organizations/create`}
        element={
          <RequireWritePermission resource="organizations" action="create">
            <OrganizationCreatePage />
          </RequireWritePermission>
        }
      />
      <Route
        path={`/organizations/:id`}
        element={
          <RequireReadPermission resource="organizations">
            <OrganizationDetailsPage />
          </RequireReadPermission>
        }
      />
      <Route
        path={`/organizations/:id/edit`}
        element={
          <RequireWritePermission resource="organizations" action="update">
            <OrganizationEditPage isEdit />
          </RequireWritePermission>
        }
      />
    </React.Fragment>,

    <React.Fragment key={'partners'}>
      <Route
        path={`/partners`}
        element={
          <RequireReadPermission resource="partners">
            <PartnerListPage />
          </RequireReadPermission>
        }
      />
      <Route
        path={`/partners/create`}
        element={
          <RequireWritePermission resource="partners" action="create">
            <PartnerCreatePage />
          </RequireWritePermission>
        }
      />
      <Route
        path={`/partners/:id`}
        element={
          <RequireReadPermission resource="partners">
            <PartnerDetailsPage />
          </RequireReadPermission>
        }
      />
      <Route
        path={`/partners/:id/edit`}
        element={
          <RequireWritePermission resource="partners" action="update">
            <PartnerEditPage />
          </RequireWritePermission>
        }
      />
    </React.Fragment>,

    <React.Fragment key={'products'}>
      <Route
        path={`/products`}
        element={
          <RequireReadPermission resource="products">
            <ProductListPage />
          </RequireReadPermission>
        }
      />
      <Route
        path={`/products/create`}
        element={
          <RequireWritePermission resource="products" action="create">
            <ProductCreatePage />
          </RequireWritePermission>
        }
      />
      <Route
        path={`/products/:id`}
        element={
          <RequireReadPermission resource="products">
            <ProductDetailsPage />
          </RequireReadPermission>
        }
      />
      <Route
        path={`/products/:id/edit`}
        element={
          <RequireWritePermission resource="products" action="update">
            <ProductEditPage />
          </RequireWritePermission>
        }
      />
    </React.Fragment>,

    <React.Fragment key={'subscriptions'}>
      <Route
        path={`/subscriptions`}
        element={
          <RequireReadPermission resource="subscriptions">
            <SubscriptionListPage />
          </RequireReadPermission>
        }
      />
      <Route
        path={`/subscriptions/create`}
        element={
          <RequireWritePermission resource="subscriptions" action="create">
            <SubscriptionCreatePage />
          </RequireWritePermission>
        }
      />
      <Route
        path={`/subscriptions/:id`}
        element={
          <RequireReadPermission resource="subscriptions">
            <SubscriptionDetailsPage />
          </RequireReadPermission>
        }
      />
      <Route
        path={`/subscriptions/:id/edit`}
        element={
          <RequireWritePermission resource="subscriptions" action="update">
            <SubscriptionEditPage />
          </RequireWritePermission>
        }
      />
    </React.Fragment>,

    <React.Fragment key={'meters'}>
      <Route
        path={`/meters`}
        element={
          <RequireReadPermission resource="meters">
            <MeterListPage />
          </RequireReadPermission>
        }
      />
      <Route
        path={`/meters/create`}
        element={
          <RequireWritePermission resource="meters" action="create">
            <MeterCreatePage />
          </RequireWritePermission>
        }
      />
      <Route
        path={`/meters/:id`}
        element={
          <RequireReadPermission resource="meters">
            <MeterDetailsPage />
          </RequireReadPermission>
        }
      />
      <Route
        path={`/meters/:id/edit`}
        element={
          <RequireWritePermission resource="meters" action="update">
            <MeterEditPage />
          </RequireWritePermission>
        }
      />
    </React.Fragment>,
  );
  return configuredFeatures;
};

export default AuthenticatedRoutes;
